import { useState } from 'react'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { browserRedirect } from '@eastcoal/common/utils/browser'

import { AuthExceptionCode } from '@eastcoal/shared/enums/AuthExceptionCode'

import { WxOAuth2 } from '../../WxOAuth2'
import { WxOAuth2Result } from '../../WxOAuth2/interface'
import { useFormStyles } from '../style'

import { LoginWechatProps } from './interface'

export const LoginWechat = ({ onFail }: LoginWechatProps) => {
  const { modal } = useFeedback()
  const [componentKey, setComponentKey] = useState(() => Date.now())
  const handleLogin = (result?: WxOAuth2Result) => {
    if (result?.error) {
      if (result.error.code === AuthExceptionCode.WECHAT_UNBIND) {
        onFail()
      } else {
        modal.warning({
          title: '登录失败',
          content: result.error.message
        })
        // 刷新组件以重新展示二维码
        setComponentKey(Date.now())
      }
    } else {
      browserRedirect()
    }
  }

  const { styles } = useFormStyles()

  return (
    <WxOAuth2
      key={componentKey}
      className={styles.form}
      onLogin={handleLogin}
    />
  )
}
